/**
 * Shared Supabase Client
 * Singleton on globalThis so HMR does not spawn extra GoTrueClient instances.
 */

import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/env';

const anonAuthStorageKey = 'roadserve-anon-auth';
const globalKey = '__roadserve_anon_supabase__';

function createAnonClient() {
  return createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      storageKey: anonAuthStorageKey,
    },
    realtime: {
      params: {
        eventsPerSecond: 10,
      },
    },
  });
}

function getAnonClient() {
  if (typeof globalThis !== 'undefined' && globalThis[globalKey]) {
    return globalThis[globalKey];
  }
  const client = createAnonClient();
  if (typeof globalThis !== 'undefined') {
    globalThis[globalKey] = client;
  }
  return client;
}

export const supabase = getAnonClient();
